import { useContext } from "react";
import { useNavigate } from "react-router-dom";
import AuthContext from "../../components/context/AuthContext";
import { getExpirationTime } from "../../components/authorization/TimeMethods";
import axios from "axios";

const useLogin = ({ state, dispatch, ACTIONS }) => {
  const authCtx = useContext(AuthContext);
  const navigate = useNavigate();

  // Username handler.
  const usernameChangedHandler = (event) => {
    dispatch({
      type: ACTIONS.INPUT_USERNAME,
      value: event.target.value,
    });
  };

  // Password handler.
  const passwordChangedHandler = (event) => {
    dispatch({
      type: ACTIONS.INPUT_PASSWORD,
      value: event.target.value,
    });
  };

  // Clear status handler.
  const statusClearedHandler = () => {
    dispatch({ type: ACTIONS.CLEAR_STATUS });
  };

  // Login submission checks.
  const loginChecksPassed = (response) => {
    // Check group memberships.
    if (response?.groupMemberships?.length === 0) {
      dispatch({ type: ACTIONS.LOGIN_ACCOUNT_DISABLED });
      return false;
    }

    // Check token.
    if (response?.token == null) {
      dispatch({
        type: ACTIONS.LOGIN_ERROR,
        value: "Authentication failed: no token was returned from the server!",
      });
      return false;
    }

    return true;
  };

  // Check the response for valid parameters.
  const responseValid = (response) => {
    if (
      response == null ||
      response?.status == null ||
      response?.data == null
    ) {
      dispatch({
        type: ACTIONS.LOGIN_ERROR,
        value: "Authentication failed.",
      });
      return false;
    }
    if (response.status !== 200) {
      dispatch({
        type: ACTIONS.LOGIN_ERROR,
        value: `Error: ${response.status} ${response.data}`,
      });
      return false;
    }
    return true;
  };

  // Login submit handler.
  const loginFormHandler = (event) => {
    event.preventDefault();
    if (!state.formValid) return;
    dispatch({ type: ACTIONS.ATTEMPT_LOGIN });
    let url = `${process.env.REACT_APP_API_URL}/ad/login`;
    let obj = { username: state.username, password: state.password };
    axios
      .post(url, obj, {})
      .then(async (response) => {
        if (!responseValid(response)) return;
        if (loginChecksPassed(response.data)) {
          response.data["expirationTime"] = getExpirationTime(
            response.data.token
          );
          dispatch({ type: ACTIONS.LOGIN_SUCCESS });
          authCtx.login(response.data);
          navigate("/home");
        }
      })
      .catch((error) => {
        dispatch({
          type: ACTIONS.LOGIN_ERROR,
          value: error?.response?.data ? `${error.response.data}` : `${error}`,
        });
      });
  };

  return {
    loginFormHandler,
    passwordChangedHandler,
    statusClearedHandler,
    usernameChangedHandler,
  };
};

export default useLogin;
